import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "St. John Accounting & Tax";
const TITLES = {
  "/": `${SITE} | Owasso–Tulsa`,
  "/services": "Services",
  "/team": "Meet Our Team",
  "/resources": "Client Resources",
  "/resources/tax-due-dates": "2026 Tax Due Dates",
  "/resources/tax-rates": "Federal Tax Rates",
  "/resources/record-retention-guide": "Record Retention Guide",
  "/resources/tax-glossary": "Tax Glossary",
  "/resources/taxpayer-rights": "Taxpayer Bill of Rights",
  "/resources/irs-forms": "IRS Forms",
  "/resources/irs-publications": "IRS Publications",
  "/resources/refund": "Where's My Refund",
  "/resources/withholding": "IRS Tax Withholding Estimator",
  "/resources/subscribe-to-tax-calendar": "Subscribe to Tax Calendar",
  "/resources/tax-appointment-checklist": "Tax Appointment Checklist",
  "/contact": "Contact Us",
  "/disclaimer": "Transparency Statement",
  "/privacy": "Privacy Policy",
  "/admin": "Admin",
};

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const t = TITLES[pathname.replace(/\/+$/, "") || "/"];
    document.title = !t ? `Page Not Found | ${SITE}` : pathname === "/" ? t : `${t} | ${SITE}`;
  }, [pathname]);
  return null;
}
